module.exports = __webpack_public_path__ + "assets/GoldGamma2x.7cc1156d1739111db2ce302a720b44ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldGamma2x.png
// module id = 810
// module chunks = 0